import { useQuery } from '@tanstack/react-query';
import { AgenticInsightsApi } from '@/features/agentic-insights/api/agenticInsightsApi';
import { agenticInsightsQueryKeys } from '@/features/agentic-insights/queryKeys';
import { useAgenticRunDataSource } from './agenticRunDataSource';
import { getRunListFixture } from './fixtures';
import type { RunSummary } from './types';

/** Backs the run picker. No polling — the list changes only when a new run is triggered. */
export const useRunList = (loopId: number) => {
  const { dataSource } = useAgenticRunDataSource();

  return useQuery<RunSummary[]>({
    queryKey: agenticInsightsQueryKeys.list.detail(dataSource, loopId),
    queryFn: () =>
      dataSource === 'mock'
        ? Promise.resolve(getRunListFixture(loopId))
        : AgenticInsightsApi.listRuns(loopId),
    // dataSource is part of the query key, so toggling Sample data would otherwise empty the list
    // for an instant — long enough for the run picker to unmount and pop back in. Keeping the
    // previous source's data on screen until the new fetch resolves avoids that flash.
    placeholderData: (previousData) => previousData,
  });
};
